import {React,useState} from "react";
 import Modalimage from "../report/modalimage"
const Renderreportcheck = ({ list, onclick, lastBookElementRef }) => {
  const  [isOpenimage,setisOpenimage] = useState(false);
  const [imageurl, setimageurl] = useState("");
  const [typeimage, settypeimage] = useState(0);

  const handleCancelimage = (event) => {
    setisOpenimage(false);
    // setPageNumber(1);
    // setyearid(event.currentTarget.value);
 
  };
  const handleOnClickimage =(imageurl) =>{

    setimageurl(imageurl)
   setisOpenimage(true);
  };
  return (

    <>
        <Modalimage
    isOpen={isOpenimage}
    onCancel={handleCancelimage}
    imageurl={imageurl}
    type={"jpg"}
  />
      <div className="col-lg-12 m-0">
        {list &&
          list.length > 0 &&
          list.map((item, index) => {
            return (
              <div key={index} ref={lastBookElementRef}>
                <div className="card shadow my-1 " >
                  <div className="row m-2 ">
                    <div className="col-xs-6   col-lg-4  col-xl-3  ">
                      <span className ="badge badge-pill badge-warning" style={{ fontSize: 12 }}>  {index+1}</span>
                     
                      <h6 className="" style={{ fontSize: 13 }}>
                        วันที่ตรวจ : 
                        <span className=" text-primary" style={{ fontSize: 13 }}>
                        {item.daterecode}
                        </span>
                      </h6>
                      <h6 className="me-1" style={{ fontSize: 13 }}>
                        พื้นที่ :
                        <span className="text-primary" style={{ fontSize: 13 }}>
                        {item.locationname}
                        {" / "}
                        {item.areaName}
                          {" / "}
                          {item.detailname}
                        </span>
                      </h6>
                    </div>

                    <div className="col-xs-6   col-lg-4  col-xl-3  ">
                      <h6 className="">
                        <span className="me-1" style={{ fontSize: 13 }}>
                          รหัส :
                        </span>
                        <span className="text-primary" style={{ fontSize: 13 }}>
                        {item.itemname}
                        </span>
                      </h6>

                      <h6 className="me-1" style={{ fontSize: 13 }}>
                        ประเภท : 
                        <span className="text-primary" style={{ fontSize: 13 }}>
                        {item.equipmentname}
                        </span>
                      </h6>

                      <div />
                    </div>
                    {/* {console.log(item)} */}
                    <div className="col-xs-6  col-lg-4  col-xl-3 ">
                      <h6 className="me-1" style={{ fontSize: 13 }}>
                        ผลการตรวจ :
                        {/* "text-danger" */}
                        <span className={item.result ==true ?"text-success":"text-danger" } style={{ fontSize: 13 }}>  
                        {item.result1}
                        </span>
                      </h6>

                      <h6 className="me-1" style={{ fontSize: 13 }}>
                        หมายเหตุ :
                        <span className="text-primary" style={{ fontSize: 13 }}>
                        {item.remark}
                        </span>
                      </h6>
                    </div>
                    <div className="col-xs-6  col-lg-4  col-xl-3">
                      <h6 className="" style={{ fontSize: 18 }}>
                        <div className="row" style={{ marginLeft: 3 }}>      
                                      
                         {item.image &&
                            item.image.length > 0 &&
                            item.image.map((item1, index) => {
               
                              return (
                                
                                <div className="col-auto" key={index}>
                                  <img
                                        className=" ms-2 m-1 img-fluid"
                                        onClick={() =>
                                          handleOnClickimage(item1.photo)}
                                        style={{
                                          width: "30px",
                                          height: "35px",
                                          cursor: "pointer",
                                        }}
                                        src={item1.photo}    alt="..."
                                        // src={`data:image/png;base64,${
                                        //   item.image.length
                                        //     ? item.image.photo
                                        //     : ""
                                        // }`}
                                        // alt="Red dot"
                                      />
                                  {/* <i
                                    className="fas fa-images text-info"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      handleOnClickimage(
                                        item1.photo,
                                        // item1.filetype
                                      )
                                    }
                                  ></i> */}
                                </div>
                              );
                            })}
                     

                         
                        </div>
                      </h6>

                      <h6 className="me-1" style={{ fontSize: 13 }}>
                        ชื่อผู้ตรวจ : 
                        <span className="text-primary "style={{ fontSize: 13 }}>
                          {/* <small style={{ fontSize: 15 }}> */} 
                          {item.user}
                          {/* </small> */}
                        </span>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};

export default Renderreportcheck;
